import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { FeatureHubContextProvider } from '@feature-hub/react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { App } from './app';
import { apolloClient } from './apollo-client';
import { createFeatureHubClientIntegration } from './utils/create-integrator';
import type { PortalWindow } from './types';

declare const window: PortalWindow;

type FeatureAppModuleSource = {
  readonly url: string;
  readonly moduleType?: string;
};

const getUrlsForHydrationFromDom = (): FeatureAppModuleSource[] => {
  const scriptElement = document.querySelector('script[type="x-feature-hub/urls-for-hydration"]');

  if (!scriptElement || !scriptElement.textContent) {
    return [];
  }

  return JSON.parse(scriptElement.textContent);
};

(async () => {
  const baseUrl = window.__BASE_URL__;
  const environment = window.__ENV__;

  const client = apolloClient({
    uri: `${baseUrl}/bff`,
    isBrowser: true,
    state: window?.__APOLLO_STATE__
  });

  const container = document.querySelector('#e-charge');
  const { featureAppManager } = createFeatureHubClientIntegration();
  const urlsForHydration = getUrlsForHydrationFromDom();

  await Promise.all(
    urlsForHydration.map(async ({ url, moduleType }) =>
      featureAppManager.preloadFeatureApp(url, moduleType)
    )
  );

  hydrateRoot(
    container!,
    <React.StrictMode>
      <ApolloProvider client={client}>
        <FeatureHubContextProvider value={{ featureAppManager }}>
          <BrowserRouter>
            <App baseUrl={baseUrl} environment={environment} />
          </BrowserRouter>
        </FeatureHubContextProvider>
      </ApolloProvider>
    </React.StrictMode>
  );
  // eslint-disable-next-line no-console
})().catch(console.error);
